/**
 * @file 开始使用页路由
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import Install from './Install';
import CustomerInfo from './pages/customer-info/CustomerInfo';

const InstallRouter = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/install/quick" component={Install} />
                <Route path="/install/FastDeploy" component={Install} />
                <Route path="/install/other" component={Install} />
                <Route path="/install/old" component={Install} />
                <Route path="/install/customerinfo" component={CustomerInfo} />
                <Route path="/install/next" component={Install} />
                <Redirect path="/" to="/install/quick" />
            </Switch>
        </BrowserRouter>
    );
};

export default InstallRouter;
